module.exports = __webpack_public_path__ + "img/路线图页-地图B.f0a11e6c.png";